/**
 * Rename CCM19 banner buttons to client-requested labels (EN).
 * Prefer updating texts in CCM19 admin when session is available;
 * this keeps the live storefront aligned without waiting on admin access.
 */
(function () {
  var LABELS = {
    accept: 'Accept all',
    decline: 'Decline optional cookies',
    settings: 'Set preferences'
  };

  var INTRO_FROM = /By clicking [“"„]?Accept(?: All)?[”"]?, you consent to the use of ALL the cookies\./i;
  var INTRO_TO = 'By clicking „Accept All”, you consent to the use of all the cookies.';

  function setLabel(el, text) {
    if (!el || !text) return;
    if ((el.textContent || '').trim() === text && el.getAttribute('aria-label') === text) return;
    el.textContent = text;
    el.setAttribute('aria-label', text);
  }

  function rewriteIntro(scope) {
    var el = (scope || document).querySelector('#ccm-widget .ccm-widget--introduction .ccm--p')
      || (scope || document).querySelector('#ccm-widget .ccm-widget--introduction');
    if (!el) return;
    var html = el.innerHTML;
    if (!INTRO_FROM.test(html) || html.indexOf(INTRO_TO) !== -1) return;
    el.innerHTML = html.replace(INTRO_FROM, INTRO_TO);
  }

  function rename(root) {
    var scope = root || document;
    setLabel(scope.querySelector('#ccm-widget button[data-full-consent="true"]'), LABELS.accept);
    setLabel(scope.querySelector('#ccm-widget button.ccm--decline-cookies'), LABELS.decline);
    setLabel(scope.querySelector('#ccm-widget button[data-ccm-modal="ccm-control-panel"]'), LABELS.settings);
    rewriteIntro(scope);
  }

  function start() {
    rename(document);
    var widget = document.getElementById('ccm-widget');
    if (!widget || typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function () {
      rename(document);
    });
    obs.observe(widget, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('ccm19WidgetOpened', function () {
    rename(document);
  });
})();
